<template>
  <section class="credibility-section">
    <div class="container">
      <h2 class="section-title">Terbukti Diminati Pasar: Portofolio Sukses dari Seruma</h2>
      <p class="section-subtitle">
        Sejak 2017, Seruma konsisten menghadirkan proyek properti yang menjadi investasi bernilai tinggi dan terbukti diminati pasar.
      </p>
      <div class="projects-grid">
        
        <div class="project-card">
          <div class="card-image">
            <img src="https://firebasestorage.googleapis.com/v0/b/paradisa-project.firebasestorage.app/o/web_assets%2Fghv1.jpg?alt=media&token=830a60ab-c89b-4b73-b65d-6db747a16dd9" alt="Green Harris View 1">
            <div class="sold-out-badge">SOLD OUT</div>
          </div>
          <div class="card-content">
            <h3>Green Harris View 1</h3>
            <p class="project-stats">
              <strong>5 Rumah, 21 Kamar</strong> terjual habis dalam <strong>2 Bulan</strong>
            </p>
            <p class="project-concept">
              Mengusung konsep kost premium Industrial Japandi di daerah CIFOR Kota Bogor.
            </p>
          </div>
        </div>

        <div class="project-card">
          <div class="card-image">
            <img src="https://firebasestorage.googleapis.com/v0/b/paradisa-project.firebasestorage.app/o/web_assets%2Fghv2.jpg?alt=media&token=edc3bd6c-9902-47c2-9fc6-13caffeed50f" alt="Green Harris View 2">
            <div class="sold-out-badge">SOLD OUT</div>
          </div>
          <div class="card-content">
            <h3>Green Harris View 2</h3>
            <p class="project-stats">
              <strong>25 Rumah, 141 Kamar</strong> terjual habis dalam <strong>7 Bulan</strong>
            </p>
            <p class="project-concept">
              Mengusung konsep Coliving 'Cozy Homey Vibes' dengan fasilitas tambahan seperti resto dan communal area.
            </p>
          </div>
        </div>

        <div class="project-card">
          <div class="card-image">
            <img src="https://firebasestorage.googleapis.com/v0/b/paradisa-project.firebasestorage.app/o/web_assets%2Fghvp.png?alt=media&token=a0af9657-b4a9-412a-9c90-6b998a08b3b7" alt="GHV Premiere">
            <div class="sold-out-badge">SOLD OUT</div>
          </div>
          <div class="card-content">
            <h3>GHV Premiere</h3>
            <p class="project-stats">
              <strong>36 Rumah, 216 Kamar</strong> terjual habis dalam <strong>8 Bulan</strong>
            </p>
            <p class="project-concept">
              Hunian Hybrid yang menggabungkan konsep Apartment Kost dengan legalitas Landed House (SHM).
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CredibilityBlock'
}
</script>

<style scoped>
.credibility-section {
  background-color: var(--light-grey); /* Kita gunakan lagi warna abu-abu di sini untuk memisahkan section */
  padding: 80px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.section-title {
  font-size: 2.2rem;
  margin-bottom: 15px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #555;
  max-width: 700px;
  margin: 0 auto 50px auto;
  line-height: 1.6;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  text-align: left;
}

.project-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 25px rgba(0,0,0,0.07);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.project-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0,0,0,0.12);
}

.card-image {
  position: relative;
  height: 220px;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sold-out-badge {
  position: absolute;
  top: 15px;
  right: -35px;
  background-color: var(--success-color);
  color: white;
  padding: 8px 40px;
  font-weight: 700;
  font-size: 14px;
  transform: rotate(45deg);
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.card-content {
  padding: 25px;
}

.card-content h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.4rem;
  color: var(--primary-color);
}

.project-stats {
  font-size: 1rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 500;
}

.project-concept {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

/* Aturan untuk Tablet & Mobile */
@media (max-width: 992px) {
  .projects-grid {
    grid-template-columns: 1fr;
  }
}
</style>